import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { LanguageSwitch } from './LanguageSwitch';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';
export function Header() {
  const {
    language
  } = useLanguage();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <header className="sticky top-0 z-50 bg-white border-b border-gray-200" data-id="element-107">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
        <div className="flex justify-between items-center h-16" data-id="element-109">
          <button onClick={scrollToTop} className="text-xl font-bold text-gray-900 hover:text-gray-700 transition-colors" data-id="element-110">
            AfriCard Compare
          </button>

          <LanguageSwitch data-id="element-111" />
        </div>
      </nav>
    </header>;
}